import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { ReportService } from 'src/app/repository/service/report.service';

@Component({
  selector: 'app-vi-summary',
  templateUrl: './vi-summary.component.html',
  styleUrls: ['./vi-summary.component.scss']
})
export class ViSummaryComponent implements OnInit, OnDestroy {

  constructor(public reportService: ReportService,
    public notifier: NotifierService) { }
  ngOnDestroy(): void {
    this.reportService.summaryInnerHtml = "";
    this.reportService.summarySafeInnerHtml = "";
    this.reportService.selectedFileForSummary = {};
    this.reportService.close();
    // console.log("this.reportService.summarySafeInnerHtml ===> ",this.reportService.summarySafeInnerHtml)
  }

  ngOnInit(): void {

  }

  copySummary() {
    const contentDiv = document.querySelector('.summary-body-external') as HTMLElement;
    // Use the Range API to get the content of the div
    const range = document.createRange();
    range.selectNodeContents(contentDiv);
    // Use a temporary selection to copy the content
    const selection = window.getSelection();
    selection?.removeAllRanges();
    selection?.addRange(range);
    try {
      // Execute the copy command
      const successful = document.execCommand('copy');
      if (successful) {
        this.notifier.notify('success','Summary copied to clipboard!')
      } else {
        this.notifier.notify('error','Copy summry failed.')
      }
    } catch (err) {
      this.notifier.notify('error','Something went wrong while copying summry')
    }
    // Deselect the content after copying
    selection?.removeAllRanges();
  }

}
